
import router from "@/router";
import { defineComponent, ref, onBeforeMount } from "vue";

import {
  collection,
  doc,
  setDoc,
  getDoc,
  arrayUnion,
  updateDoc,
} from "firebase/firestore";
import { db } from "@/firebase/index";

import Game from "@/types/Game";
import Player from "@/types/Player";

export default defineComponent({
  setup() {
    const joinGameId = ref("");
    const playerName = ref("");
    const loadingJoin = ref(false);
    const loadingCreate = ref(false);

    const storePlayerName = () => {
      localStorage.setItem("wrwlfPname", playerName.value || "Guest");
    };

    const generateRandomGameId = () => {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const nums = "0123456789";
      let id = "";
      for (let i = 0; i < 6; i++) {
        let randomIndex: number;
        if (i % 2 == 0) {
          randomIndex = Math.floor(Math.random() * chars.length);
          id += chars[randomIndex];
        } else {
          randomIndex = Math.floor(Math.random() * nums.length);
          id += nums[randomIndex];
        }
      }
      return id;
    };

    const joinExistingGame = async () => {
      loadingJoin.value = true;
      storePlayerName();
      // GET PID
      let pid = `${localStorage.getItem("wrwlfPid")}`;
      // GET GAME BY ID
      const gameRef = doc(db, "games", joinGameId.value.toUpperCase());
      const gameSnap = await getDoc(gameRef);
      // CHECK IF GAME EXISTS
      if (!gameSnap.exists()) {
        alert("Game ID does not exist");
        loadingJoin.value = false;
        return;
      }
      // CHECK IF GAME STATUS == lobby
      if (gameSnap.data().status == "lobby") {
        // ADD TO ARRAY AN REDIRECT
        let newPlayer: Player = {
          isAlive: true,
          role: "",
          name: playerName.value,
          reveal: false,
          pid: pid,
        };
        await updateDoc(gameRef, {
          players: arrayUnion(newPlayer),
        });
        router.push(`/lobby/${joinGameId.value.toUpperCase()}`);
      }
      // REDIRECT TO GAME VIEW
      if (gameSnap.data().status == "inGame") {
        router.push(`/game/${joinGameId.value}`);
      }
      loadingJoin.value = false;
    };

    const createNewGame = async () => {
      loadingCreate.value = true;
      storePlayerName();
      try {
        let docId = await firestoreCreateGame();
        router.push(`/lobby/${docId}`);
      } catch (err) {
        console.log(err);
      }
      loadingCreate.value = false;
    };

    const firestoreCreateGame = async () => {
      let gameId = generateRandomGameId();
      let game: Game = {
        status: "lobby",
        created: Date.now(),
        step: "wrwlf",
        createdBy: `${localStorage.getItem("wrwlfPid")}`,
        players: [
          {
            isAlive: true,
            role: "",
            name: playerName.value,
            reveal: false,
            pid: `${localStorage.getItem("wrwlfPid")}`,
          },
        ],
      };
      const gamesRef = collection(db, "games");
      await setDoc(doc(gamesRef, gameId), game);
      return gameId;
    };

    const generateRandomPid = () => {
      return `${Math.floor(Math.random() * 9999999999)}`;
    };

    onBeforeMount(async () => {
      // HANDLE PID
      const pid = localStorage.getItem("wrwlfPid");
      if (!pid) {
        let id = generateRandomPid();
        localStorage.setItem("wrwlfPid", id);
      }
      // HANDLE PNAME
      playerName.value = localStorage.getItem("wrwlfPname") || "";
    });
    return {
      playerName,
      loadingJoin,
      loadingCreate,
      joinGameId,
      storePlayerName,
      joinExistingGame,
      createNewGame,
      generateRandomGameId,
      firestoreCreateGame,
    };
  },
});
